// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Espot from '@tcp/core/src/components/common/molecules/Espot';
import { PLACE_CASH_COUPON_NON_ESPOT } from '@tcp/core/src/services/abstractors/CnC/CartItemTile.js';
import style from '../styles/ErrorMessage.style';
import { getIconPath } from '../../../../../../../utils';

class ErrorMessage extends React.PureComponent {
  render() {
    const { error, className, fontSize, fontWeight, isEspot, icon, isCloseable, handleClose } =
      this.props;
    const IsPlaceCashNonEspot = !PLACE_CASH_COUPON_NON_ESPOT.includes(error);
    return (
      <>
        {error && (
          <div className={className} role="alert">
            <div className="err-message-container">
              <div className="warning-icon" aria-disabled="true" />
              {isEspot ? (
                <Espot richTextHtml={error} />
              ) : (
                <BodyCopy
                  component="span"
                  color="error"
                  fontFamily="secondary"
                  fontWeight={IsPlaceCashNonEspot ? '700' : fontWeight}
                  fontSize={fontSize}
                  aria-live="assertive"
                  role="alert"
                  icon={icon}
                >
                  {error}
                </BodyCopy>
              )}
            </div>
            {isCloseable && (
              <Button
                type="button"
                ariaLabel="close"
                smallLink
                data-locator="errorClose"
                className="close-btn"
                onClick={handleClose}
              >
                <Image
                  alt="close"
                  src={getIconPath('close-cross-red')}
                  data-locator="errorCloseIcon"
                />
              </Button>
            )}
          </div>
        )}
      </>
    );
  }
}

ErrorMessage.propTypes = {
  error: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  isEspot: PropTypes.bool,
  icon: PropTypes.string,
  isCloseable: PropTypes.bool,
  handleClose: PropTypes.func,
};

ErrorMessage.defaultProps = {
  error: '',
  className: '',
  fontSize: 'fs10',
  fontWeight: 'normal',
  isEspot: false,
  icon: 'circle-alert-fill',
  isCloseable: false,
  handleClose: () => {},
};

export default withStyles(ErrorMessage, style);

export { ErrorMessage };
